import React, { useState } from "react";
import {
  Button,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  ListItemButton,
  ListItemText,
  MenuItem,
  Typography,
  currentTheme,
  ThemeProvider,
  createTheme,
} from "@common-ui/ui";
import { useDispatch, useSelector } from "react-redux";
import { Check } from "@mui/icons-material";
import { organizationSlice } from "../../reducers/organizationReducer";
import { updateUserProfile } from "../../services";
import { sliceToChunk } from "../../utils";
import { Dialog } from "@mui/material";
import { useHistory } from "react-router-dom";
const theme = createTheme(currentTheme, {
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 4,
          height: "37px",
          fontFamily: "Roboto",
        },
      },
      defaultProps: {
        disableElevation: true,
      },
    },
  },
  typography: {
    h1: {
      fontFamily: "Roboto",
      fontSize: "3.8rem",
      fontWeight: 200,
    },
    h2: {
      fontFamily: "Roboto",
      fontSize: "2.5rem",
      fontWeight: 400,
    },
    h3: {
      fontFamily: "Roboto",
      fontSize: "1.875rem",
      fontWeight: 500,
    },
    h4: {
      fontFamily: "Roboto",
      fontSize: "1.5rem",
      fontWeight: 500,
    },
    h5: {
      fontFamily: "Roboto",
      fontSize: "1.1rem",
      fontWeight: 600,
    },
    h6: {
      fontFamily: "Open Sans",
      fontSize: "1.1rem",
      fontWeight: 700,
    },
    fontFamily: "Open Sans",
    subtitle1: {
      fontWeight: 700,
      fontSize: "0.8rem",
      lineHeight: 1.55,
    },
    button: {
      fontWeight: 600,
      fontFamily: "Roboto Nato",
      lineHeight: 2,
      strokeWidth: 2,
      textTransform: "capitalize",
      borderRadius: 30,
    },
    overline: {
      lineHeight: 2.52,
      fontSize: "0.7rem",
      fontWeight: 600,
    },
    subtitle2: {
      fontWeight: 800,
    },
    fontSize: 14,
    body1: {
      fontSize: "0.9rem",
    },
    body2: {
      fontSize: "0.8rem",
    },
  },
});
export function SwitchOrganization() {
  const [intentOrg, setIntentOrg] = useState(null);
  let viewMore = false;
  const router = useHistory();
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();
  let organizations = useSelector((state) => state.organization.organizations);
  const currentOrganization = useSelector(
    (state) => state.organization.currentOrganization
  );
  if (organizations && organizations?.length && organizations?.length > 5) {
    organizations = sliceToChunk(organizations, 5)[0];
    viewMore = true;
  }

  const handleChange = async (organization) => {
    setIntentOrg(organization.screen_name || organization.name);
    handleOpen(organization);
  };
  const handleOpen = (organization) => {
    setOpen(true);
    setIntentOrg(organization);
  };

  const handleClose = async (confirm) => {
    if (confirm === true) {
      await updateUserProfile({ current_org: intentOrg.id });
      dispatch(organizationSlice.actions.setCurrentOrganization(intentOrg));
      window.location.href = "/";
    }
    setOpen(false);
  };

  return (
    <>
      {organizations.map((org, i) => {
        return (
          <MenuItem
            onClick={(event) => {
              event.stopPropagation();
              handleChange(org);
            }}
            sx={{ ml: 1 }}
            key={i}
            value={org.id}
          >
            {/* <ListItemIcon>
              <Business fontSize="small" />
            </ListItemIcon> */}
            <ListItemText>{org.screen_name || org.name}</ListItemText>
            {org.id === currentOrganization?.id ? (
              <Typography variant="body2" color="text.secondary">
                <Check fontSize="small" />
              </Typography>
            ) : (
              ""
            )}
          </MenuItem>
        );
      })}
      {viewMore ? (
        <ListItemButton
          onClick={() => router.push("/orgs/tree-view/overview")}
          sx={{ ml: 1 }}
          fontWeigth="700"
        >
          View All
        </ListItemButton>
      ) : (
        ""
      )}

      <ThemeProvider theme={theme}>
        <Dialog
          open={open}
          onClose={() => handleClose(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            This will sign you out of{" "}
            {currentOrganization?.screen_name || currentOrganization?.name}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Do you want to sign-in to{" "}
              {intentOrg?.screen_name || intentOrg?.name}?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => handleClose(false)}>No</Button>
            <Button onClick={() => handleClose(true)} autoFocus>
              Yes
            </Button>
          </DialogActions>
        </Dialog>
      </ThemeProvider>
    </>
  );
}
